import { BrowserRouter } from "react-router-dom";

import { AppProviders } from "@/app/AppProviders";
import { InAppBlocker } from "@/app/InAppBlocker";
import { MaintenanceBlocker } from "@/app/MaintenanceBlocker";
import { useThemeColor } from "@/hooks/app/useThemeColor";
import { Pages } from "@/router";
import OfflineMode from "@/Services/OfflineMode";

function App() {
    useThemeColor();

    return (
        <AppProviders>
            <InAppBlocker>
                <MaintenanceBlocker>
                    <BrowserRouter>
                        <Pages />
                    </BrowserRouter>

                    <OfflineMode />
                </MaintenanceBlocker>
            </InAppBlocker>
        </AppProviders>
    );
}

export default App;
